define('lib/Podio.UI.Video',['require','jquery','lib/Podio.Event.UI','lib/Podio.UI.Modal'],function(require) {

  var $ = require('jquery');
  var eventUI = require('lib/Podio.Event.UI');
  var Modal = require('lib/Podio.UI.Modal');

  // Adding YouTube iframe API script tag at the right time, but not in the template, in order to avoid situation of
  // calling window.onYouTubeIframeAPIReady() before it was actually declared
  // Instruction taken from from https://developers.google.com/youtube/training/player/chapter-marker/102
  function _addYouTubeIframeAPIScriptTag() {
    var scriptTag = document.createElement('script');
    var firstScriptTag = document.getElementsByTagName('script')[0];

    scriptTag.src = '//www.youtube.com/iframe_api';
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
  }

  // Refactored to let the iframe have an 'id' attribute
  function _generateYoutubeFrame(videoUrl, options) {
    var iframeTemplate = '<iframe ' + ((options && options.id) ? 'id="{4}"' : '') + 'width="{0}" height="{1}" src="https://www.youtube.com/embed/{2}?autoplay={3}" frameborder="0" allowfullscreen></iframe>';
    var youtubeVideoId;

    if (videoUrl.indexOf('watch?') !== -1) {
      var match = videoUrl.match(/v=[a-zA-Z0-9_-]+/);
      if (match) {
        youtubeVideoId = match[0].split('=').pop();
      }
    } else if (videoUrl.indexOf('embed/') !== -1) {
      youtubeVideoId = videoUrl.match(/embed\/([a-zA-Z0-9_-]+)/)[1];
    }

    options = $.extend({
      width: 680,
      height: 413,
      autoplay: 1
    }, options);

    return iframeTemplate.format(
      options.width,
      options.height,
      youtubeVideoId,
      options.autoplay,
      options.id
    );
  }

  function youtubeLinkHandler(elmTarget, e) {
    var videoUrl = elmTarget.data('video');
    var modalTitle = elmTarget.attr('title');
    var showInPlace = elmTarget.hasClass('in-place-video');

    if (showInPlace) {
      showYoutubeInPlace(elmTarget, videoUrl);
    } else {
      showYoutubeModal(videoUrl, modalTitle);
    }
  }

  function showYoutubeModal(videoUrl, title) {
    var content = _generateYoutubeFrame(videoUrl);
    Modal.show(content, {title: title, flat: true});
  }

  function showYoutubeInPlace(elmTarget, videoUrl) {
    var videoId = elmTarget.attr('id');
    var width = elmTarget.width();
    var height = elmTarget.height();
    var content = _generateYoutubeFrame(videoUrl, { id: videoId, width: width, height: height });

    _addYouTubeIframeAPIScriptTag();
    elmTarget.replaceWith(content);
  }

  eventUI.bind('click', '.youtube-link', youtubeLinkHandler);

  return {
    showYoutubeModal: showYoutubeModal,
    showYoutubeInPlace: showYoutubeInPlace
  };

});

